module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("aDuvp"))).then(() => parcelRequire('1iHdE'));